"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonAddressFields = void 0;
var entities_1 = require("@common/entities");
var FIELDS = [
    __assign(__assign({}, entities_1.InstitutionAddressFields.streetLine1), { customType: entities_1.FieldType.Text, enabled: true, isAddress: true, required: true, sequence: 1, type: entities_1.FieldType.Text }),
    __assign(__assign({}, entities_1.InstitutionAddressFields.streetLine2), { customType: entities_1.FieldType.Text, enabled: true, isAddress: true, required: false, sequence: 2, type: entities_1.FieldType.Text }),
    __assign(__assign({}, entities_1.InstitutionAddressFields.streetLine3), { customType: entities_1.FieldType.Text, enabled: true, isAddress: true, required: false, sequence: 3, type: entities_1.FieldType.Text }),
    __assign(__assign({}, entities_1.InstitutionAddressFields.city), { customType: entities_1.FieldType.Text, enabled: true, isAddress: true, required: true, sequence: 4, type: entities_1.FieldType.Text }),
    __assign(__assign({}, entities_1.InstitutionAddressFields.countryCode), { customType: entities_1.FieldType.CountryDropdown, enabled: true, isAddress: true, options: [], required: true, sequence: 5, type: entities_1.FieldType.CountryDropdown }),
    __assign(__assign({}, entities_1.InstitutionAddressFields.stateCode), { customType: entities_1.FieldType.StateDropdown, enabled: true, isAddress: true, options: [], required: true, sequence: 6, type: entities_1.FieldType.StateDropdown }),
    __assign(__assign({}, entities_1.InstitutionAddressFields.postalCode), { customType: entities_1.FieldType.ZipCode, enabled: true, isAddress: true, required: true, sequence: 7, type: entities_1.FieldType.ZipCode }),
];
/**
 * @param startSequence - The sequence number to start with
 * @returns An array of address fields
 */
var getCommonAddressFields = function (startSequence) {
    if (startSequence === void 0) { startSequence = 1; }
    var sequence = startSequence;
    return FIELDS.map(function (field) { return (__assign(__assign({}, field), { sequence: sequence++ })); });
};
exports.getCommonAddressFields = getCommonAddressFields;
